import { formatDate, subDays, subHours, subMonths, subWeeks, subYears } from './dateUtils';

export type PeriodType = 'days' | 'weeks' | 'months' | 'years' | 'hours';

/** Maps a period type string to the corresponding date-fns subtract function. */
const SUBTRACT_FN: Record<PeriodType, (date: Date, amount: number) => Date> = {
  days: subDays,
  weeks: subWeeks,
  months: subMonths,
  years: subYears,
  hours: subHours,
};

/**
 * Generates an array of formatted date strings, each offset from now.
 *
 * @param numberOfOptions - Number of items to generate.
 * @param type - Period unit: 'days' | 'weeks' | 'months' | 'years' | 'hours'.
 * @param format - A date-fns format string (e.g. 'MMMM', 'yyyy').
 */
const getDateOptions = (numberOfOptions: number, type: PeriodType, format: string): string[] => {
  const subtractFn = SUBTRACT_FN[type];
  if (!subtractFn) return [];
  const options: string[] = [];
  for (let i = 0; i < numberOfOptions; i++) {
    options.push(formatDate(subtractFn(new Date(), i), format));
  }
  return options;
};

export default getDateOptions;
